import types from './types'

export const fetchingNetSuiteAssetsMe = () => ({
  type: types.FETCHING_NETSUITE_ASSETS_ME,
})

export const fetchingNetSuiteAssetsMeSuccess = netSuiteAssets => ({
  type: types.FETCHING_NETSUITE_ASSETS_ME_SUCCESS,
  netSuiteAssets,
})

export const fetchingNetSuiteAssetsMeError = error => ({
  type: types.FETCHING_NETSUITE_ASSETS_ME_ERROR,
  error,
})

export const fetchingNetSuiteAssets = () => ({
  type: types.FETCHING_NETSUITE_ASSETS,
})

export const fetchingNetSuiteAssetsSuccess = netSuiteAssets => ({
  type: types.FETCHING_NETSUITE_ASSETS_SUCCESS,
  netSuiteAssets,
})

export const fetchingNetSuiteAssetsError = error => ({
  type: types.FETCHING_NETSUITE_ASSETS_ERROR,
  error,
})

export const assigningNetSuiteAsset = () => ({
  type: types.ASSIGNING_NETSUITE_ASSET,
})

export const assigningNetSuiteAssetSuccess = netSuiteAsset => ({
  type: types.ASSIGNING_NETSUITE_ASSET_SUCCESS,
  netSuiteAsset,
})

export const assigningNetSuiteAssetError = error => ({
  type: types.ASSIGNING_NETSUITE_ASSET_ERROR,
  error,
})
